import {INewClientRequest} from '../dtos';
import {IProofPaymentRequest} from '../dtos/proof-payment-request.interface';
import {IOrderRequest} from '../services/order-request.interface';

export type ResultOfRequestCached = {
  status: 'ok' | 'fail' | 'for-cache';
  request?: INewClientRequest | IProofPaymentRequest | IOrderRequest;
};

export const RESULT_REQUEST_CACHED_OK = {
  status: 'ok',
} as ResultOfRequestCached;

export const RESULT_REQUEST_CACHED_FAILED = {
  status: 'fail',
} as ResultOfRequestCached;

export const RESULT_REQUEST_CACHED_ON_STORAGE = {
  status: 'for-cache',
} as ResultOfRequestCached;
